<template lang="pug">
.pricing-cost-calculator
  el-row(:gutter="32")
    el-col(:sm="12")
      el-card.el-card--modern(
        shadow="never")
        .header(slot="header")
          .flex.aic
            .icon.pr-1
              img(src="/img/frost-icon.calculator-gray.webp" width="48" height="48" alt="Deduction Free")
            .content
              h2 Traditional Costing
              p What's happening to the margin?

        table.costing
          tbody
            tr
              td
                help-tag(tooltip="COGS + Freight") Case Pack Cost ($)
              td
                el-input-number(
                  size="medium"
                  :min="0"
                  v-model="form.casePackCost")
            tr.sub
              td Brand Margin (%)
              td
                percentage-input(
                  type="el-input-number"
                  size="medium"
                  :min="0"
                  v-model="form.brandMargin")
            tr
              td Distributor Price
              td
                .read-only {{ costing.traditional.distributorPrice | usd }}
            tr.sub
              td Distributor margin (%)
              td
                percentage-input(
                  type="el-input-number"
                  size="medium"
                  :min="0"
                  v-model="form.traditionalDistributorMargin")
            tr
              td Wholesale Price
              td
                .read-only {{ costing.traditional.wholesalePrice | usd }}
            tr.sub
              td Store Margin
              td
                percentage-input(
                  type="el-input-number"
                  size="medium"
                  :min="0"
                  v-model="form.storeMargin")
            tr
              td Consumer Price
              td
                .read-only {{ costing.traditional.consumerPrice | usd }}
              td
            tr.sub
              td Deductions % (Mandatory on All Sales)
                //- .note Avg deductions per&nbsp;
                //-   nuxt-link.linked(:to="{ name: 'pricing-earnings-calculator' }") 2022 case study
              td.deductions
                percentage-input(
                  type="el-input-number"
                  size="medium"
                  :min="0"
                  v-model.number="form.traditionalDeductions")
            tr.sub
              td Off-Invoice Promotion % (Mandatory)
              td
                percentage-input(
                  type="el-input-number"
                  size="medium"
                  :min="0"
                  v-model.number="form.offInvoicePromotion")
            tr
              td
                help-tag(tooltip="Your take home after distributor invoice/deductions.") Pay Out Realized
              td
                .read-only {{ costing.traditional.payOutRealized | usd }}
            tr.summary
              td Gross Margin
              td
                .read-only {{ costing.traditional.grossMargin | fixer | percentage }}

    el-col(:sm="12")
      el-card.el-card--modern(shadow="never")
        .header(slot="header")
          .flex.aic
            .icon.pr-1
              img(src="/img/frost-icon.dollar-black.webp" width="48" height="48" alt="Pod Costing")
            .content
              h2 Pod Costing
              p Pod gives you the control.

        table.costing
          tbody
            tr
              td
                help-tag(tooltip="COGS + Freight") Case Pack Cost ($)
              td
                el-input-number(
                  size="medium"
                  :min="0"
                  v-model="form.casePackCost")
            tr.sub
              td Brand Margin (%)
              td
                percentage-input(
                  type="el-input-number"
                  size="medium"
                  :min="0"
                  v-model="form.brandMargin")
            tr
              td
                help-tag(tooltip="The fee for an ambient case turning in 30 days") Pod Storage Fees
              td
                el-input-number(
                  size="medium"
                  :min="0"
                  v-model.number="form.podStorageFees")
                  span(slot="prepend") $
            tr.sub
              td Pod Service Fee
              td
                el-select(
                  v-model="form.podServiceFee"
                  size="medium")
                  el-option(
                    v-for="i, k in [0.18, 0.22, 0.25]"
                    :value="i"
                    :label="$options.filters.percentage(i)"
                    :key="k") {{ i | percentage }}
                //- el-radio-group(
                  v-model="form.podServiceFee"
                  size="medium")
                  el-radio-button(:label="0.18") 18%
                  el-radio-button(:label="0.22") 22%
                  el-radio-button(:label="0.25") 25%
            tr
              td
                help-tag(tooltip="Aka Wholesale Price") Direct to Retail Price
              td
                el-input-number(
                  size="medium"
                  :min="0"
                  :precision="2"
                  v-model="form.podDirectToStorePrice")
                  span(slot="prepend") $
            tr.sub
              td Store Margin (%)
              td
                percentage-input(
                  type="el-input-number"
                  size="medium"
                  :min="0"
                  v-model="form.storeMargin")
                  span(slot="append") %
            tr
              td Consumer Price ($)
              td
                el-input-number(
                  size="medium"
                  :min="0"
                  :precision="2"
                  v-model="form.podConsumerPrice")
                  span(slot="prepend") $
              td
            tr.sub
              td Deductions % (Mandatory on All Sales)
              td.deductions
                .read-only {{ costing.pod.deductions | fixer | percentage }}
            tr.sub
              td Off-Invoice Promotion % (Optional)
              td
                percentage-input(
                  type="el-input-number"
                  size="medium"
                  :min="0"
                  v-model.number="form.offInvoicePromotion")
            tr
              td
                help-tag(tooltip="Your take home from Pod.") Pay Out Realized
              td
                .read-only {{ costing.pod.payOutRealized | usd }}
            tr.summary
              td Gross Margin
              td
                .read-only {{ costing.pod.grossMargin | fixer | percentage }}
</template>

<script>
import PercentageInput from '~/components/inputs/PercentageInput'

export default {
  components: {
    PercentageInput
  },

  filters: {
    fixer (number) {
      if (isNaN(number) || !isFinite(number)) return null
      return number
    }
  },

  data () {
    return {
      form: {
        casePackCost: 20,
        brandMargin: 0.35,
        storeMargin: 0.45,
        offInvoicePromotion: 0,
        traditionalDistributorMargin: 0.18,
        traditionalDeductions: 0.1659,
        podStorageFees: 0.8,
        podServiceFee: 0.22,
        podConsumerPrice: 68.22,
        podDirectToStorePrice: 68.22 * (1 - 0.45)
      }
    }
  },

  computed: {
    costing () {
      const {
        casePackCost,
        brandMargin,
        storeMargin,
        offInvoicePromotion,
        traditionalDistributorMargin,
        traditionalDeductions,
        podStorageFees,
        podServiceFee,
        podDirectToStorePrice
      } = this.form

      const traditional = {}
      traditional.distributorPrice = casePackCost / (1 - brandMargin)
      traditional.wholesalePrice = traditional.distributorPrice / (1 - traditionalDistributorMargin)
      traditional.consumerPrice = traditional.wholesalePrice / (1 - storeMargin)
      traditional.payOutRealized = traditional.distributorPrice *
        (1 - traditionalDeductions) -
        (offInvoicePromotion * traditional.wholesalePrice)
      traditional.grossMargin = (traditional.payOutRealized - casePackCost) / traditional.wholesalePrice

      const pod = {}
      pod.deductions = 0
      pod.payOutRealized = podDirectToStorePrice *
        (1 - podServiceFee) -
        (podDirectToStorePrice * offInvoicePromotion) -
        podStorageFees
      pod.grossMargin = (pod.payOutRealized - casePackCost) / podDirectToStorePrice

      return {
        traditional,
        pod
      }
    }
  },

  watch: {
    'form.podConsumerPrice' (val) {
      this.$set(
        this.form,
        'podDirectToStorePrice',
        val * (1 - this.form.storeMargin))
    },

    'form.podDirectToStorePrice' (val) {
      this.$set(
        this.form,
        'podConsumerPrice',
        val / (1 - this.form.storeMargin)
      )
    },

    'form.storeMargin' (val) {
      this.$set(
        this.form,
        'podConsumerPrice',
        this.form.podDirectToStorePrice / (1 - val)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.pricing-cost-calculator {
  .el-card--modern {
    background: white;
    border: 1px solid rgba(white, .2);
    border-radius: 20px;
    color: $--color-text-regular;
    ::v-deep {
      .el-card__header {
        border-bottom: none;
      }
    }
  }
  .header {
    text-align: left;
    padding: .25em 0 1em .25em;
    border-bottom: $--border-light;
    h2 {
      font-size: 18px;
      font-weight: $--font-weight-normal;
      margin: 0;
    }
    p {
      margin: 0;
      font-weight: $--font-weight-normal;
      margin-top: .35em;
      color: $--color-text-secondary;
    }
  }
  table.costing {
    margin: .5em 0;
    border-collapse: collapse;
    width: 100%;
    ::v-deep {
      input[type=number] {
        appearance: textfield;
        -moz-appearance: textfield;
        margin: 0;
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
      }
      .el-input {
        &__inner {
          text-align: center;
        }
      }
      .el-input-group {
        position: relative;
        > input {
          text-align: center;
          border-radius: $--radius;
          padding-left: 24px;
          padding-right: 24px;
        }
        &__append,
        &__prepend {
          position: absolute;
          top: 0;
          bottom: 0;
          background: transparent;
          border: none;
          line-height: 28px;
          padding: 0;
          text-align: center;
          min-width: 24px;
        }
        &__append {
          right: 0;
        }
        &__prepend {
          left: 0;
        }
      }
      .el-radio-group {
        display: flex;
        > * {
          min-width: 0;
          flex: 1;
        }
      }
      .el-radio-button {
        &__inner {
          padding-left: .5em;
          padding-right: .5em;
          width: 100%;
        }
      }
    }
    tr {
      td {
        padding: 1em 0;
        &:first-child {
          font-weight: $--font-weight-bold;
          text-align: left;
          text-transform: uppercase;
          font-size: 13px;
        }
        &:nth-child(2) {
          padding: .2em 1em;
          text-align: center;
          > * {
            width: 100%;
            max-width: 150px;
            margin-left: auto;
            margin-right: auto;
          }
        }
        &.deductions {
          padding-top: 1em;
          padding-bottom: 1em;
        }
      }
      &.sub {
        td {
          &:first-child {
            font-weight: $--font-weight-normal;
          }
          &:nth-child(2) {
            color: $--color-primary;
          }
        }
      }
    }
  }
  .note {
    font-size: .9em;
    text-transform: none;
    color: #D4D8DC;
  }
  .read-only {
    display: block;
    min-height: 36px;
    line-height: 36px;
    padding: 0;
    text-align: center;
    background-color: #EFE2F1;
    color: $--color-text-regular;
    border-radius: $--radius;
    box-sizing: border-box;
    font-weight: $--font-weight-bold;
  }
}
</style>
